// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__cwQpu","footerFlex":"Footer_footerFlex__Avr0+"};